import _ from 'lodash';

export const FILTER_TYPES = {
  MULTICHOICE: 'multichoice',
  RANGE: 'range'
};

const filterTypesMap = {
  [FILTER_TYPES.MULTICHOICE]: ['panelists', 'tags', 'sentiments'],
  [FILTER_TYPES.RANGE]: ['likes']
};

const commonFilterObject = {
  title: null,
  columnId: null,
  error: false,
  visible: false,
  loading: false
};


const multichoiceFilterObject = {
  ...commonFilterObject,
  options: [],
  searchQuery: null,
  selectAllTitle: null,
  isAllSelected: false
};

const multichoiceFilterOption = {
  id: null,
  name: null,
  selected: false
};

const rangeFilterObject = {
  ...commonFilterObject,
  from: 0,
  to: 0,
  min: 0,
  max: 0
};

export const getCommonFilterObject = (columnId = null) => {
  return {...commonFilterObject, columnId};
};

export const getMultichoiceFilterObject = (columnId = null) => {
  return {...multichoiceFilterObject, columnId};
};

export const getMultichoiceFilterOption = ({id, name, selected}) => {
  return {...multichoiceFilterOption, id, name, selected};
};

export const getRangeFilterObject = (columnId = null) => {
  return {...rangeFilterObject, columnId};
};

export const getFilterObject = (columnId = null) => {
  const filterType = getFilterTypeByColumnId(columnId);
  switch (filterType) {
	case FILTER_TYPES.MULTICHOICE:
	  return getMultichoiceFilterObject(columnId);
	case FILTER_TYPES.RANGE:
	  return getRangeFilterObject(columnId);
	default:
	  return null;
  }
};

export const isMultichoiceFilterType = (name = '') => ( filterTypesMap['multichoice'].indexOf(name.toLowerCase()) > -1);

export const isRangeFilterType = (name = '') => ( filterTypesMap['range'].indexOf(name.toLowerCase()) > -1);

export const isFilterInArray = (columnId = null, filters = []) => {
  return getFilterByColumnId(columnId, filters) !== null;
};

export const getFilterIndexByColumnId = (columnId, filters) => {
  return _.findIndex(filters, {columnId});
};

export const getFilterTypeByColumnId = (columnId = '') => {
  return Object.keys(filterTypesMap).filter((filterType) => {
	return filterTypesMap[filterType].indexOf(columnId) > -1
  })[0];
};

export const getFilterByColumnId = (columnId = null, filters = []) => {
  //console.log('Searching filter: ', columnId, filters);
  return _.find(filters, {columnId: columnId}) || null;
};

export const overwriteFilter = (filter, filters) => {
  const idx = getFilterIndexByColumnId(filter.columnId, filters);
  filters[idx] = {...filter};

  return filters;
};

export const hideAllFilters = ({filters}) => {
  return [...filters].map((filter) => {
	const filterClone = {...filter};
	filterClone.visible = false;
	return filterClone;
  });
};

export const setFilterVisibleValue = ({filters, columnId, value}) => {
  return [...filters].map((filter) => {
	const filterClone = {...filter};
	filterClone.visible = filter.columnId === columnId ? value : false;
	return filterClone;
  });
};

export const setFilterLoadingValue = ({filters, columnId, value}) => {
  return [...filters].map((filter) => {
	const filterClone = {...filter};
	filterClone.loading = filter.columnId === columnId ? value : false;
	return filterClone;
  });
};


export const serverObjectToClient = (clientObject, serverObject) => {
  const filterType = getFilterTypeByColumnId(clientObject.columnId);
  if (!filterType) {
	return clientObject;
  }
  return converters[getFilterTypeByColumnId(clientObject.columnId)].serverObjectToClient(clientObject, serverObject);
};

export const clientObjectToServer = (clientObject, serverObject = {}) => {
  const filterType = getFilterTypeByColumnId(clientObject.columnId);
  if (!filterType) {
	return clientObject;
  }
  return converters[getFilterTypeByColumnId(clientObject.columnId)].clientObjectToServer(clientObject, serverObject);
};

const converters = {
  [FILTER_TYPES.MULTICHOICE]: {
	serverObjectToClient: (clientObject, serverObject) => {
	  console.log('ServerObject: ', serverObject);
	  const {
		  selectAllTitle,
		  title,
		  filterItemList,
		  isSelectAll,
		  totalFilterItemCount,
		  clearStr,
		  noOptionsStr,
		  loadMoreStr,
		  applyStr,
		  cancelStr,
		  searchPhStr,
		  filterSelectionCountStr,
		  filterAllSelectionCountStr,
		  selectAllCountStr,
		  hasMore,
		  searchQuery
	  } = serverObject;

	  return ({
		...clientObject,
		selectAllTitle,
		title,
		options: filterItemList,
		isAllSelected: isSelectAll,
		totalFilterItemCount,
		clearStr,
		loadMoreStr,
		applyStr,
		cancelStr,
		noOptionsStr,
		searchPh: searchPhStr,
		filterSelectionCountStr,
		filterAllSelectionCountStr,
		selectAllCountStr,
		hasMore,
		searchQuery
	  });
	},
	clientObjectToServer: (clientObject, serverObject) => {
	  console.log('Converting: ', clientObject, serverObject);
	  const filterItemList = [...clientObject.options];
	  const valueIds = filterItemList.filter((item) => item.selected === true).map((option) => {
		return option.id
	  });
	  return ({
		...serverObject,
		filterItemList,
		valueIds
	  });
	}
  },
  [FILTER_TYPES.RANGE]: {
	serverObjectToClient: (clientObject, serverObject) => {
	  const {title, from, to, min, max, applyStr, cancelStr, clearStr, fromStr, toStr} = serverObject;

	  return ({
		...clientObject,
		title,
		from,
		to,
		min,
		max,
		applyStr,
		cancelStr,
		clearStr,
		fromStr,
		toStr
	  });
	},
	clientObjectToServer: (clientObject, serverObject) => {
	  const {from, to} = clientObject;

	  return ({
		...serverObject,
		from,
		to
	  })
	}
  }
};



// WEBPACK FOOTER //
// ./common/utils/Tables/filters.js